import common from './common';
import operators from './operators';
import resources from './resources';
import ui from './ui';

export default { ui, resources, common, operators };
